import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  class: "min-h-screen",
  "data-theme": "amber"
}
const _hoisted_2 = { class: "max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-8" }
const _hoisted_3 = {
  href: '/shops',
  class: "text-sm text-blue-700 hover:text-blue-900 mb-6 inline-block"
}
const _hoisted_4 = { class: "bg-white rounded-xl shadow-sm border border-gray-200 p-6" }
const _hoisted_5 = { class: "flex items-center gap-3 mb-4" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "text-2xl font-bold text-gray-900" }
const _hoisted_8 = {
  key: 1,
  class: "inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium bg-blue-100 text-blue-800"
}
const _hoisted_9 = {
  key: 0,
  class: "mb-4"
}
const _hoisted_10 = { class: "inline-flex items-center px-3 py-1.5 rounded-full text-sm font-medium bg-yellow-100 text-yellow-800 mr-2" }
const _hoisted_11 = {
  key: 1,
  class: "mb-4"
}
const _hoisted_12 = { class: "inline-flex items-center px-3 py-1.5 rounded-full text-sm font-medium bg-yellow-100 text-yellow-800" }
const _hoisted_13 = {
  key: 2,
  class: "mb-6"
}
const _hoisted_14 = { class: "text-sm font-semibold text-gray-700 mb-2" }
const _hoisted_15 = { class: "flex flex-wrap gap-2" }
const _hoisted_16 = {
  key: 3,
  class: "text-gray-600 mb-6 whitespace-pre-line"
}
const _hoisted_17 = ["href"]
const _hoisted_18 = {
  key: 5,
  class: "mb-6"
}
const _hoisted_19 = {
  key: 0,
  class: "text-sm font-semibold text-gray-700 mb-2"
}
const _hoisted_20 = {
  key: 1,
  class: "flex flex-wrap gap-2 mb-3"
}
const _hoisted_21 = { class: "rounded-lg border border-gray-200 overflow-hidden map-container" }
const _hoisted_22 = {
  ref: "mapContainer",
  style: {"height":"300px","width":"100%"}
}
const _hoisted_23 = {
  key: 6,
  class: "flex gap-3 mt-4"
}
const _hoisted_24 = ["href"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode($setup["NavBar"], {
      "signed-in": $props.signedIn,
      "user-name": $props.userName,
      "active-page": "shops"
    }, null, 8 /* PROPS */, ["signed-in", "user-name"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("a", _hoisted_3, "← " + _toDisplayString($setup.t('shops.back_to_list')), 1 /* TEXT */),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          ($setup.shop.logo_url)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: $setup.shop.logo_url,
                class: "w-16 h-16 rounded-lg object-cover border border-gray-200 shrink-0"
              }, null, 8 /* PROPS */, _hoisted_6))
            : _createCommentVNode("v-if", true),
          _createElementVNode("h1", _hoisted_7, _toDisplayString($setup.shop.name), 1 /* TEXT */),
          ($setup.shop.category)
            ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString($setup.t('shops.category_' + $setup.shop.category)), 1 /* TEXT */))
            : _createCommentVNode("v-if", true)
        ]),
        ($setup.shop.pending && $props.userAdmin)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createElementVNode("span", _hoisted_10, _toDisplayString($setup.t('shops.pending')), 1 /* TEXT */),
              _createElementVNode("button", {
                onClick: $setup.approveItem,
                class: "px-4 py-1.5 text-sm font-medium text-green-700 bg-green-50 rounded-lg hover:bg-green-100 transition"
              }, _toDisplayString($setup.t('shops.approve')), 1 /* TEXT */)
            ]))
          : ($setup.shop.pending)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createElementVNode("span", _hoisted_12, _toDisplayString($setup.t('shops.pending')), 1 /* TEXT */)
              ]))
            : _createCommentVNode("v-if", true),
        ($setup.shop.brands && $setup.shop.brands.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              _createElementVNode("h3", _hoisted_14, _toDisplayString($setup.t('shops.brands')), 1 /* TEXT */),
              _createElementVNode("div", _hoisted_15, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.shop.brands, (b) => {
                  return (_openBlock(), _createElementBlock("span", {
                    key: b,
                    class: "inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium bg-amber-100 text-amber-800"
                  }, _toDisplayString(b), 1 /* TEXT */))
                }), 128 /* KEYED_FRAGMENT */))
              ])
            ]))
          : _createCommentVNode("v-if", true),
        ($setup.shop.description)
          ? (_openBlock(), _createElementBlock("p", _hoisted_16, _toDisplayString($setup.shop.description), 1 /* TEXT */))
          : _createCommentVNode("v-if", true),
        ($setup.shop.link)
          ? (_openBlock(), _createElementBlock("a", {
              key: 4,
              href: $setup.shop.link,
              target: "_blank",
              class: "inline-flex items-center gap-2 px-4 py-2 text-sm font-medium text-white bg-blue-700 rounded-lg hover:bg-blue-800 transition mb-6"
            }, [
              _createTextVNode(_toDisplayString($setup.t('shops.visit_link')) + " ", 1 /* TEXT */),
              _cache[0] || (_cache[0] = _createElementVNode("svg", {
                class: "w-4 h-4",
                fill: "none",
                stroke: "currentColor",
                viewBox: "0 0 24 24"
              }, [
                _createElementVNode("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "2",
                  d: "M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
                })
              ], -1 /* CACHED */))
            ], 8 /* PROPS */, _hoisted_17))
          : _createCommentVNode("v-if", true),
        _createCommentVNode(" Locations "),
        ($setup.locationsWithCoords.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
              ($setup.locationsWithCoords.length > 1)
                ? (_openBlock(), _createElementBlock("h3", _hoisted_19, _toDisplayString($setup.t('shops.locations')) + " (" + _toDisplayString($setup.locationsWithCoords.length) + ")", 1 /* TEXT */))
                : _createCommentVNode("v-if", true),
              ($setup.locationsWithCoords.length > 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.locationsWithCoords, (loc) => {
                      return (_openBlock(), _createElementBlock("span", {
                        key: loc.id,
                        class: "inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium bg-blue-50 text-blue-700"
                      }, _toDisplayString([loc.name, loc.address].filter(Boolean).join(' — ') || $setup.t('shops.location')), 1 /* TEXT */))
                    }), 128 /* KEYED_FRAGMENT */))
                  ]))
                : _createCommentVNode("v-if", true),
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, null, 512 /* NEED_PATCH */)
              ])
            ]))
          : _createCommentVNode("v-if", true),
        ($props.userAdmin || $setup.shop.user_id === $props.userId)
          ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
              _createElementVNode("a", {
                href: `/shops?edit=${$setup.shop.id}`,
                class: "px-4 py-2 text-sm font-medium text-blue-700 bg-blue-50 rounded-lg hover:bg-blue-100 transition"
              }, _toDisplayString($setup.t('shops.edit')), 9 /* TEXT, PROPS */, _hoisted_24),
              _createElementVNode("button", {
                onClick: $setup.deleteItem,
                class: "px-4 py-2 text-sm font-medium text-red-700 bg-red-50 rounded-lg hover:bg-red-100 transition"
              }, _toDisplayString($setup.t('shops.delete')), 1 /* TEXT */)
            ]))
          : _createCommentVNode("v-if", true)
      ])
    ])
  ]))
}